import React from 'react';
import { Box, Center, Button, useDisclosure, Heading } from '@chakra-ui/react';

import { useImaginationRoom } from '@invitato/imagination-room';
import useLang from '@/hooks/useLang';

import WithAnimation from '@/components/Common/WithAnimation';
import ImageHover from '@/components/Common/ImageHover';

import { IMG_PHOTO_1, IMG_PHOTO_2 } from '@/constants/assets';
import { ENABLE_SPACE_BRIDE_GROOM } from '@/constants/feature-flags';

import { BOY_NAME_SHORT, GIRL_NAME_SHORT, IS_BOY_FIRST } from '@/constants';

import Content from './Content';
import txtWording from './locales';
import { TEXT_PROPS } from '@/constants/default-props';

function PhotoSection() {
  const defaultLang = useLang();
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();

  const lang = defaultLang;
  const IMAGES = [
    onGetFinalContent('IMG_PHOTO_1', IMG_PHOTO_1),
    onGetFinalContent('IMG_PHOTO_2', IMG_PHOTO_2),
  ];

  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <Box bgColor="bgPrimary" padding="32px 0 32px 0" textAlign="center">
      <Heading
        {...TEXT_PROPS.body_lv2}
        color="mainColorText"
        fontWeight="normal"
        textTransform="uppercase"
        letterSpacing="4px"
      >
        Gallery of
      </Heading>
      <Heading
        {...TEXT_PROPS.subHeading}
        textTransform="uppercase"
        letterSpacing="4px"
        color="mainColorText"
      >
        {IS_BOY_FIRST
          ? onGetFinalName('groomName', BOY_NAME_SHORT)
          : onGetFinalName('brideName', GIRL_NAME_SHORT)}{' '}
        &
      </Heading>
      <Heading
        {...TEXT_PROPS.subHeading}
        marginTop={ENABLE_SPACE_BRIDE_GROOM ? '-8px' : '-16px'}
        textTransform="uppercase"
        letterSpacing="4px"
        color="mainColorText"
      >
        {IS_BOY_FIRST
          ? onGetFinalName('brideName', GIRL_NAME_SHORT)
          : onGetFinalName('groomName', BOY_NAME_SHORT)}
      </Heading>
      <Center marginTop="40px">
        <Box>
          <ImageHover zIndex={1} images={IMAGES} imageProps={{ height: '250px', width: '250px' }} />
        </Box>
      </Center>

      {/* Button Section */}
      <WithAnimation>
        <Center>
          <Button
            {...TEXT_PROPS.body}
            size="sm"
            fontWeight="light"
            bgColor="bgAlternative"
            color="mainColorTextLight"
            fontSize="md"
            // textTransform="uppercase"
            fontStyle="italic"
            marginTop="20px"
            onClick={() => onOpen()}
          >
            {txtWording.btnGallery[lang]}
          </Button>
        </Center>
      </WithAnimation>
      {/* Content gallery */}
      <Content isOpen={isOpen} onClose={onClose} />
    </Box>
  );
}

export default React.memo(PhotoSection);
